import React from 'react';
import { Box } from '@chakra-ui/react';
import { Navbar } from '../components/Navbar';
import { HeroSection } from '../components/HeroSection';
import { CollectionCategories } from '../components/CollectionCategories';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { BrandStory } from '../components/BrandStory';
import { PopUpBanner } from '../components/PopUpBanner';
import { InstagramFeed } from '../components/InstagramFeed';
import { NewsletterSignup } from '../components/NewsletterSignup';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <Box as="main" w="100%" minH="100vh" overflowX="hidden" data-id="element-175">
      <Navbar data-id="element-176" />
      <HeroSection data-id="element-177" />
      <CollectionCategories data-id="element-178" />
      <FeaturedProducts data-id="element-179" />
      <BrandStory data-id="element-180" />
      <PopUpBanner data-id="element-181" />
      <InstagramFeed data-id="element-182" />
      <NewsletterSignup data-id="element-183" />
      <Footer data-id="element-184" />
    </Box>;
}